export default "__VITE_ASSET__eda5f82a__"